module.exports = __webpack_public_path__ + "static/img/7.f9d8dfb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/zh/7.png
// module id = xVfV
// module chunks = 0